import { render } from "./BanksEdit.vue?vue&type=template&id=64a296d3&scoped=true"
import script from "./BanksEdit.vue?vue&type=script&lang=js"
export * from "./BanksEdit.vue?vue&type=script&lang=js"

import "./BanksEdit.vue?vue&type=style&index=0&id=64a296d3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a296d3"]])

export default __exports__